import { State } from '~/modules';

export interface IEnvironment {
  localStorageWhiteList: string[];
  debug: boolean;
  production: boolean;
  configuration: ConfigurationEnum;
  buildDate: Date;
  appVersion: string;
  appId: string;
  appTitle: string;
  accessApp?: {
    appId: string;
    uri: string;
    deepLinks: {
      authentication: {
        success: string;
        cancel: string;
        error: string;
      };
      paymentConfirmation: {
        success: string;
        cancel: string;
        error: string;
      };
    };
  };
  chat: {
    lazyLoadMessagesCount: number;
    maxPdfFileSizeBytes?: number;
  };
  storeLinks: {
    ios: string;
    android: string;
  };
  mocks?: {
    state: State;
    services: { original: unknown; mock: unknown }[];
  };
  appBuildNumber: string;
  defaultTimeout: number;
  notificationDurationMs?: number;
  contractNumberPatterns: Record<EnvironmentEnum, RegExp>;
  featureFlags: {
    isChatOnMainScreen: boolean;
    isCardEnabled: boolean;
    isInvestmentsEnabled: boolean;
    darkModeEnabled: boolean;
    isLanguageSwitchEnabled: boolean;
    dynamicAssets: boolean;
    isCgeNewsEnabled: boolean;
    isCashAccountSlideEnabled: boolean;
    isDepositaryBanksEnabled: boolean;
    eDocumentEnabled: boolean;
    restrictEDocumentForCRM: boolean;
    customEDocumentCategoryMapping: boolean;
    showEDocumentDocumentDate: boolean;
    showCashAccountDetails: boolean;
    showPerformanceOnPortfolioCard: boolean;
    showAssetPercentagesOnPortfolioCard: boolean;
    attachmentOverChatEnabled: boolean;
    showDebitedNetAmount: boolean;
    showSimAvailability: boolean;
    pdfOverChatEnabled: boolean;
    checkPaymentsAuthorized: boolean;
    forcedPickClientForRM: boolean;
    isClientSideSessionTimeoutEnabled: boolean;
    showPerformanceChartsAxis: boolean;
    useCumulativePerformanceLineChart: boolean;
  };
  payment: {
    maxAmount: number;
  };
}

export enum EnvironmentEnum {
  PROD = 'production',
  UAT = 'uat',
  TEST = 'test',
  DEMO = 'demo',
  SANDBOX = 'sandbox'
}

export enum ConfigurationEnum {
  TEST = 'configuration-test',
  UAT = 'configuration-uat',
  PRODUCTION = 'configuration-production',
  TEST_EBANKING = 'configuration-test-ebanking',
  UAT_EBANKING = 'configuration-uat-ebanking',
  PRODUCTION_EBANKING = 'configuration-production-ebanking',
  DEMO = 'configuration-demo',
  SANDBOX = 'configuration-sandbox',
  TEST_LOCAL = 'configuration-test-local',
  UAT_LOCAL = 'configuration-uat-local',
  MOCK_CLIENT = 'mock_client',
  MOCK_CRM_USER = 'mock_crm_user'
}
